module.exports = __webpack_public_path__ + "static/media/zebras-1883654_1280.a3b75926.jpg";